import { Directive, HostListener, inject, Input } from '@angular/core';
import { Router } from '@angular/router';

@Directive({
  selector: '[appNavigateBack]'
})
export class NavigateBackDirective {
  private _router = inject(Router);
  @Input() appNavigateBack: string; 

  @HostListener('click') onClick() {
    if (this.appNavigateBack) {
      this._router.navigate([this.appNavigateBack], { replaceUrl: true });
    } else {
      this._router.navigate(['..'], { replaceUrl: true });
    }
  }
}
